export default [
    {
        path: "dashboard",
        name: "dashboard",
        subsystemCode: "DashBoard",
        redirect: { name: 'DashboardCharts' },
        component: () => import("@/views/dashboard/Dashboard.vue"),
        children: [
            {
                path: "charts",
                name: "DashboardCharts",
                subsystemCode: "DashBoard",
                component: () => import("@/views/dashboard/DashBoardCharts.vue"),
            },
            {
                path: "start-use",
                name: "DashboardStartUse",
                subsystemCode: "DashBoard",
                component: () => import("@/views/dashboard/DashboardStartUse.vue"),
            },
        ]
    }
]